import { UserRoles } from '../../api/queries.ts';

export class PartnerAdminRolesUtils {
  public static isPartnerAdminUser(userRoles: Array<UserRoles>): boolean {
    const mustHaveRole: UserRoles = UserRoles.PARTNER_ADMIN;
    return userRoles.includes(mustHaveRole);
  }
}
